import { Typography, Box } from '@mui/material';
const Highlight = ({ children }) => (
    <span style={{ color: '#1B1464', fontWeight: 'bold' }}>{children}</span>
);
const normal = { color: '#1B1464', fontWeight: 400 };

export const faqs = [
    {
        question: "Preciso acumular um valor mínimo para resgatar meu cashback?",
        answer: (
        <>
            <Typography sx={normal}>
            <Highlight>Não</Highlight> é necessário acumular um valor mínimo para resgatar seu cashback através do <Highlight>MeuCupom Devolve</Highlight>.
            </Typography>
        </>
        ),
    },
    {
        question: "Consigo utilizar cupons de desconto junto com o cashback?",
        answer: (
        <Typography sx={normal}>
            <Highlight>Não!</Highlight> Ao efetuar login no <Highlight>MeuCupom</Highlight>, você estará apto a economizar em dobro, através dos cupons de desconto das lojas parceiras e recebendo parte do valor da sua compra de volta através do <Highlight>MeuCupom Devolve</Highlight>. Porém, não é possível utilizá-los juntos ao finalizar a sua compra.
        </Typography>
        ),
    },
    {
        question: "Onde posso verificar o status do meu cashback?",
        answer: (
        <Typography sx={normal}>
            Você pode verificar o status do seu cashback após fazer login na sua conta do <Highlight>MeuCupom</Highlight> e acessar o seu perfil do <Highlight>MeuCupom Devolve</Highlight>. Lá, você encontrará todas as informações atualizadas sobre o seu cashback, como valor, status e se existe alguma ação necessária para liberação.
        </Typography>
        ),
    },
    {
    question: "Fiz uma compra e não consigo visualizar o meu cashback?",
    answer: (
        <Box sx={normal}>
            <Typography sx={{ mb: 2 }}>
            Existem alguns motivos para que o saldo do seu cashback não esteja aparecendo em seu perfil em nosso site. Os principais são:
            </Typography>

            <Typography><Highlight>1.</Highlight> Não ter se logado no site antes de realizar a compra;</Typography>
            <Typography><Highlight>2.</Highlight> Não ter completado a compra em um único processo (ex: colocar os produtos no carrinho e realizar o pagamento em outro momento ou em outro dispositivo);</Typography>
            <Typography><Highlight>3.</Highlight> Ir diretamente para o site da loja parceira, sem ser direcionado pelo MeuCupom.com;</Typography>
            <Typography sx={{ mb: 2 }}><Highlight>4.</Highlight> O MeuCupom.com não foi o último site em que você clicou antes de finalizar a compra.</Typography>

            <Typography sx={{ mb: 2 }}>
            É importante estar sempre atento em relação a esses pontos para que o cashback seja atribuído corretamente.
            </Typography>

            <Typography>
            Caso você tenha seguido todos os passos corretamente e ainda assim não visualizou seu saldo, entre em contato com o nosso time, com as seguintes informações: nome da loja, data e valor da compra e o número do pedido, através do link abaixo:&nbsp;
            <a href="/institucional/contato" target="_blank" rel="noopener noreferrer" style={{ color: '#1B1464', textDecoration: 'underline' }}>
                Contate-nos.
            </a>
            </Typography>
        </Box>
        ),
    },
    {
        question: "Ainda não recebi o meu cashback após o prazo de pagamento",
        answer: (
        <Typography sx={normal}>
            A identificação e validação do cashback ocorre de forma independente ao envio do produto pela loja parceira. O prazo para confirmação e pagamento do cashback é de até <Highlight>90</Highlight> dias. Sabemos que o prazo é alto, mas ele se faz necessário por uma série de motivos, tais como troca, desistência ou cancelamento da compra. De qualquer forma, você não precisa se preocupar, pois sempre te avisaremos por <Highlight>e‑mail</Highlight> quando o benefício estiver aprovado e também quando realizarmos a transferência, através da chave <Highlight>PIX</Highlight> informada em seu cadastro.
        </Typography>
        ),
    },
];